const WELCOME_PATH = '/bienvenida-cliente'
const LOGOUT_PATH = '/logout.php'

const normalizarPhpUrl = (phpRedirectUrl) => {
  let normalizedUrl = phpRedirectUrl
  while (normalizedUrl.endsWith('/')) {
    normalizedUrl = normalizedUrl.slice(0, -1)
  }
  return normalizedUrl
}

export function buildWelcomeUrl(phpRedirectUrl) {
  const normalizedUrl = normalizarPhpUrl(phpRedirectUrl)

  return normalizedUrl.endsWith(WELCOME_PATH) ? normalizedUrl : `${normalizedUrl}${WELCOME_PATH}`
}

/**
 * URL de cierre de sesión del PHP legacy.
 *
 * Redirigir a la pantalla de inicio del PHP no destruye su sesión (PHPSESSID),
 * por lo que el portal sigue considerando al usuario logueado y lo deja entrar
 * sin credenciales. El PHP expone su propio logout en LOGOUT_PATH, que invalida
 * la sesión y redirige al inicio del sitio.
 */
export function buildPhpLogoutUrl(phpRedirectUrl) {
  return `${new URL(phpRedirectUrl).origin}${LOGOUT_PATH}`
}
